import { QISpinner, QIErrorBoundary } from "../../../components";
import { EventsTableWrapper } from "./EventsTableWrapper";
import { header } from "./tableHeader";
import { removeDuplicates } from "../utils";
import { NoData } from "../../Shared";

const EventList = ({
  data,
  resetCount,
  selectedRange,
  setSelectedRange,
  error,
  listData,
  setDeviceId = () => {},
  setHighlight,
  highlight,
  setMapPoint = () => {},
  listType,
  setResetCount,
  setMapExpand,
  showEventsDetails,
  setDockAlign = () => {},
  eventSearch,
  setEventSearch,
  isSuccess,
  isFetching,
  selectedId,
  setShowEventsDetails = () => {},
  batchSize,
  onBatchSizeChange = () => {},
  hasMore,
  isLoadingMore,
  onLoadMore = () => {},
}) => {
  //Handle Row Selection
  const handleRowClick = (data) => {
    setDeviceId(data?.source_id);

    if (data?.events?.type === "geofence" && ["exit", "entry"].includes(data?.events?.status)) {
      setMapPoint(
        data?.events[data?.events?.status === "entry" ? "entry_position" : "exit_position"]
      );
    } else {
      setMapPoint(data?.gps?.position);
    }
    if (data?.events?.type === "geofence" && data?.events?.sub_type === "time limit exceeded") {
      setMapPoint(data?.events?.start_position);
    }
    setShowEventsDetails(data);
  };

  const message = {
    header: error?.data?.message,
  };

  return (
    <>
      {error && <QIErrorBoundary message={message} />}
      {isFetching && (
        <div className="no-data">
          <QISpinner size="50px" />
        </div>
      )}
      {!isFetching && data?.events?.length ? (
        <EventsTableWrapper
          data={removeDuplicates(data?.events || [])}
          header={header}
          error={error}
          isSuccess={true}
          batchSize={batchSize}
          onBatchSizeChange={onBatchSizeChange}
          hasMore={hasMore}
          isLoadingMore={isLoadingMore}
          onLoadMore={onLoadMore}
          tableHandlers={{
            rowHandler: handleRowClick,
          }}
          highlight={highlight}
          setHighlight={setHighlight}
          listType={listType}
          selectedId={selectedId}
        />
      ) : (
        isSuccess && !error && !isFetching && <NoData />
      )}
    </>
  );
};

export default EventList;
